const initLazyVideos = (sliderEl) => {
  const videos = sliderEl.querySelectorAll('.review-videos__video');
  if (!videos.length) return;

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      entry.target.preload = 'metadata';
      entry.target.src = entry.target.dataset.src;
      obs.unobserve(entry.target);
    });
  }, { rootMargin: '200px' });

  videos.forEach((video) => observer.observe(video));
};

const initPlayButtons = (sliderEl) => {
  sliderEl.querySelectorAll('.review-videos__item').forEach((item) => {
    const video = item.querySelector('.review-videos__video');
    const button = item.querySelector('.review-videos__play');
    if (!video || !button) return;

    button.addEventListener('click', () => {
      if (!video.src) video.src = video.dataset.src;

      video.setAttribute('controls', '');
      item.classList.add('is-playing');
      video.play();
    });

    video.addEventListener('pause', () => item.classList.remove('is-playing'));
    video.addEventListener('ended', () => item.classList.remove('is-playing'));
  });
};

const syncLockedState = (swiper, sectionEl) => {
  sectionEl.classList.toggle('is-locked', swiper.isLocked);
};

const initReviewVideosSlider = () => {
  const sliderEl = document.querySelector('.review-videos__slider');
  if (!sliderEl) return;

  const sectionEl = sliderEl.closest('.review-videos');

  const swiper = new Swiper(sliderEl, {
    slidesPerView: 1.25,
    spaceBetween: 16,
    centeredSlides: true,
    pagination: {
      el: '.review-videos__pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.review-videos__button-next',
      prevEl: '.review-videos__button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
        centeredSlides: false,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
        centeredSlides: false,
      },
    },
  });

  swiper.on('slideChange', () => {
    sliderEl.querySelectorAll('.review-videos__video').forEach((video) => {
      if (!video.paused) video.pause();
    });
  });

  if (sectionEl) {
    swiper.on('lock', () => syncLockedState(swiper, sectionEl));
    swiper.on('unlock', () => syncLockedState(swiper, sectionEl));
    syncLockedState(swiper, sectionEl);
  }

  initLazyVideos(sliderEl);
  initPlayButtons(sliderEl);
};

export { initReviewVideosSlider };
